import axios from 'axios'

export default class InteractionTypeService {
  public getAll() {
    return axios.get('/api/v1/interaction-types')
  }
}
